import { render, staticRenderFns } from "./MRLsMatrix.vue?vue&type=template&id=1e2c3494&scoped=true"
import script from "./MRLsMatrix.vue?vue&type=script&lang=js"
export * from "./MRLsMatrix.vue?vue&type=script&lang=js"
import style0 from "./MRLsMatrix.vue?vue&type=style&index=0&id=1e2c3494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c3494",
  null
  
)

export default component.exports